export default "__VITE_ASSET__FM1gE4ls__"